import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Switch,
  Select
} from 'antd'

import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import SellAttributeImg from '../../../assets/images/sell-attribute.jpg'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { loadData } from '../../../appRedux/actions/Setting'
import { useSelector } from 'react-redux'
import {
  loadGroupAttribs,
  setCommonConfigs
} from '../../../appRedux/actions/CommonData'
import { SUPPLIER } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getDecryptID
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import AddSellAttributesGroup from '../../../components/AddSellAttributesGroup'
import { loadSellAttributeData } from '../../../appRedux/actions/Sell'
import AddSellAttributes from '../../../components/AddSellAttributes'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
const Panel = Collapse.Panel
const confirm = Modal.confirm

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const SellAttributes = ({ match }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getSellAttributeGroupsData = useSelector(
    ({ commonConfigs }) => commonConfigs.getSellAttributeGroupsData
  )
  const [isLoading, setIsLoading] = React.useState(true)
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [loadDataState, setloadDataState] = useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getSellAttributesData, setSellAttributesData] = React.useState([])
  const [pagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
  })
  const [groupID, setGroupID] = useState('xxx')

  const isloadAttributeData = useSelector(
    ({ Sell }) => Sell.isloadAttributeData
  )

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'sell.settings.sellattributes')
      }

      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    var searchObj = {
      SellAttributeID: '',
      CurrentPageNo: pagination.CurrentPageNo,
      PageSize: pagination.PageSize
    }
    getSellAttributes(searchObj)
    if (isloadAttributeData) {
      dispatch(loadSellAttributeData(false))
    }
  }, [isloadAttributeData])

  React.useEffect(() => {
    dispatch(setCommonConfigs(SUPPLIER))
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (groupID) {
        const body = {
          GroupID: groupID == 'xxx' ? '' : groupID,
          CurrentPageNo: pagination.CurrentPageNo,
          PageSize: pagination.PageSize
        }
        getSellAttributes(body)
      }
    }
    return () => {
      mounted = false
    }
  }, [groupID])

  React.useEffect(() => {
    var searchObj = {
      IsAll: true
    }
    getSellAttributeGroups(searchObj)
  }, [])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  async function postSellAttribute (body, behavior) {
    const resp = ds.addUpdateDeleteSellAttribute(body, behavior)
    await resp
      .then(res => {
        setIsLoading(false)
        if (res) {
          if (res.data) {
            let message = res.data.data
            dispatch(loadSellAttributeData(message))
            message.success(message)
          }
        } else {
          message.error(res.data.data)
        }
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
      })
  }
  async function getSellAttributeGroups (searchObj) {
    await ds
      .getSellAttributeGroups(searchObj, BEHAVIOUR_TYPE.GET)
      .then(types => {
        if (types.data.data != null) {
          const groupData = types.data.data
          dispatch(loadGroupAttribs(groupData))
          // setSellAttributeGroupsData(groupData);
          setIsLoading(false)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }
  async function getSellAttributes (searchObj) {
    setIsLoading(true)
    await ds
      .getSellAttributes(searchObj, BEHAVIOUR_TYPE.GET)
      .then(types => {
        if (types.data.data != null) {
          const groupData = types.data.data
          setSellAttributesData(groupData)
          setIsLoading(false)
          if (groupData.length > 0) {
            let paginationobj = {
              CurrentPageNo: groupData[0].currentPageNo,
              PageSize: groupData[0].pageSize,
              total: groupData[0].totalRecords
            }
            setPagination(paginationobj)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }
  const handleTableChange = (pagination, filters, sorter) => {
    var searchObj = pagination
    searchObj.CurrentPageNo = pagination.current
    searchObj.PageSize = pagination.pageSize
    // setSearchFilterData(searchObj);
    getSellAttributes(searchObj)
  }
  const columns = [
    {
      title: <IntlMessages id='sell.settings.grouptitle' />,
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: <IntlMessages id='sell.settings.groupdisplayseqno' />,
      dataIndex: 'displaySeqNo',
      key: 'displaySeqNo'
    },
    {
      title: <IntlMessages id='sell.settings.group' />,
      dataIndex: 'groupTitle',
      key: 'groupTitle'
    },
    {
      title: <IntlMessages id='sell.settings.groupactive' />,
      key: 'isActive',
      render: (text, record) => {
        const handleChageProductStatus = async (e, attrID) => {
          let body = {
            BehaviorName: 3,
            SellAttributeID: attrID,
            IsActive: e,
            IsActiveChange: true
          }
          postSellAttribute(body, BEHAVIOUR_TYPE.PUT)
        }
        return (
          <span>
            {' '}
            <Switch
              defaultChecked={record.isActive}
              onChange={e =>
                handleChageProductStatus(e, record.sellAttributeID)
              }
              // disabled={getIsDisableDelete}
            />
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='sell.settings.edit' />,
      key: 'edit',
      render: (text, record) => {
        return (
          <div>
            <AddSellAttributes behavior='3' data={record} />
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.settings.delete' />,
      key: 'delete',
      render: (text, record) => {
        const deleteProductType = async atttrID => {
          let body = {
            BehaviorName: 2,
            SellAttributeID: atttrID
          }
          postSellAttribute(body, BEHAVIOUR_TYPE.DELETE)
        }
        function showDeleteConfirm (id, title) {
          confirm({
            title: 'Are you sure delete this Attribute Group?',
            content: `"${title}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteProductType(id)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return (
          <span>
            <a
              onClick={() =>
                showDeleteConfirm(record.sellAttributeID, record.title)
              }
              style={{ color: 'red' }}
              className='gx-link'
            >
              {/* <IntlMessages id="products.productypes.delete" /> */}
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]
  return (
    <div>
      <Spin
        tip={<IntlMessages id='sell.settings.addgroup' />}
        spinning={isSpinningLoading}
        size='large'
      >
        <div className='Content-wrapper SellAttribute'>
          <Row className='align-items-center justify-content-center mb-3 SellAttribute-header'>
            {checkIsWeb().exist && (
              <Col lg={8} md={12} sm={12} xs={24}>
                <h1 className='mb-0'>
                  <IntlMessages id='sell.settings.sellattributes' />
                </h1>
              </Col>
            )}

            <Col
              lg={checkIsWeb().exist ? 8 : 12}
              md={12}
              sm={12}
              xs={24}
              className='m0-inner-row SellAttributeGroup-sp'
            >
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right '
                name='SellAttributeGroupID'
                label={'Search by Sell Attribute Group'}
              >
                <Select
                  placeholder={
                    <IntlMessages id='sell.settings.sellattributegroup' />
                  }
                  showSearch
                  optionFilterProp='children'
                  onSelect={e => {
                    setGroupID(e)
                    setPagination({
                      CurrentPageNo: 1,
                      PageSize: 10
                    })
                  }}
                  value={groupID}
                  dropdownMatchSelectWidth={200}
                >
                  {getSellAttributeGroupsData &&
                    getSellAttributeGroupsData.map((e, key) => {
                      return (
                        <option
                          key={key + 1}
                          value={getDecryptID(e.sellAttributeGroupID)}
                        >
                          {e.title}
                        </option>
                      )
                    })}
                  <option key={'xxx'} value={'xxx'}>
                    {'All Groups'}
                  </option>
                </Select>
              </Form.Item>
            </Col>

            <Col lg={checkIsWeb().exist ? 8 : 12} md={24} sm={24} xs={24}>
              <AddSellAttributes behavior='1' />
            </Col>
          </Row>

          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={false}
                header={
                  <IntlMessages id='sell.settings.sellattributeneedhelpheading' />
                }
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages id='sell.settings.sellattributeneedhelpdescription1' />
                      </p>
                      {/* <p>
                        <IntlMessages id="products.productypes.needhelpdescription2" />
                      </p> */}
                    </Col>

                    <Col md={12} className='text-center'>
                      <img
                        src={SellAttributeImg}
                        alt=''
                        className='sellattribute-img'
                      />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <div className='custom-product-table'>
            <Card className='noborder table-body'>
              {isLoading ? (
                <Skeleton count={7} height={35} />
              ) : (
                <Table
                  className='gx-table-responsive'
                  columns={columns}
                  dataSource={getSellAttributesData}
                  pagination={pagination}
                  onChange={handleTableChange}
                />
              )}
            </Card>
          </div>
        </div>
      </Spin>
    </div>
  )
}

export default SellAttributes
